import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const HubspotTypes = new Set(['hubspot', 'hubspot-lists'])

export const isHubspotWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  HubspotTypes.has(filterItem.type || filterItem.key)
